import { type EditionResponse, getEditions } from '@api/editions-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseEditionsResult {
  editions: EditionResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useEditions(): UseEditionsResult {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['editions'],
    queryFn: async () => {
      const response = await getEditions();
      return response.data;
    },
  });

  const refetch = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ['editions'] });
  }, [queryClient]);

  return {
    editions: data ?? [],
    isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to load editions') : null,
    refetch,
  };
}
